var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotification)?_c('div',[_c('v-alert',{staticClass:"box-alert",attrs:{"text":"","title":"Alert title","type":_vm.type}},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }